// removed by extract-text-webpack-plugin
module.exports = {"container":"_1c5fH_PjMvvh23p3l-z5ym","row":"n7-S1BMLCNHB88alkl39l","FooterSeparator":"_23F3zhDhc-dXIf8bbjPyHL","appIsLoading":"_2g1DrCUHSWYoy5E-MDVVGv","globalFormLockEnabled":"_1qoGUxzaHPs0fwF0ie1o1b"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisApp.scss
// module id = 1330
// module chunks = 0